<template>
  <div class="item-form-page p-5">
    <section class="page-header fade-in">
      <div>
        <h1 class="page-title">Nouvel article</h1>
        <p class="page-subtitle">
          Renseignez les informations de l'article pour l'ajouter à votre
          catalogue.
        </p>
      </div>
    </section>

    <section class="fade-in">
      <form class="" @submit.prevent="handleSubmit">
        <div class="">
          <div class="form-row">
            <div class="form-group">
              <label> Designation *</label>
              <input
                v-model.trim="form.fullName"
                type="text"
                class="form-control"
                :class="{ 'has-error': errors.fullName }"
                
              />
              <p v-if="errors.fullName" class="error-text">
                {{ errors.fullName }}
              </p>
            </div>

            <div class="form-group">
              <label> Reference </label>
              <input
                v-model.trim="form.code"
                type="text"
                class="form-control"
                
              />
            </div>
          </div>

          <!-- <div class="form-group">
            <label>Description</label>
            <textarea
              v-model.trim="form.description"
              rows="3"
              class="form-control"
              placeholder="Description de l'article"
            ></textarea>
          </div> -->

          <div class="form-row">
            <div class="form-group">
              <label>Prix TTC</label>
              <input
                v-model.number="form.priceTTC"
                type="number"
                step="0.01"
                min="0"
                class="form-control"
                
              />
            </div>
          </div>
        </div>

         <div class="form-row">
            <div class="form-group">
              <label>Code-barres</label>
              <div class="input-with-button">
                <input
                  v-model.trim="form.barCode"
                  type="text"
                  class="form-control"
                />
                <button
                  type="button"
                  class="btn-scan"
                  @click="openScanner"
                  title="Scanner le code-barres"
                >
                  <i class="bi bi-upc-scan"></i>
                </button>
              </div>
            </div>
          </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn btn-light"
            @click="goBack"
            :disabled="submitting"
          >
            Annuler
          </button>
          <button type="submit" class="btn btn-primary" :disabled="submitting">
            <i class="bi bi-check-circle"></i>
            <span v-if="!submitting">Enregistrer</span>
            <span v-else>Enregistrement...</span>
          </button>
        </div>
      </form>
    </section>

    <!-- Barcode Scanner Modal -->
    <BarcodeScannerModal
      :show="showScanner"
      :use-api="true"
      api-url="/api/items/read-barcode"
      @scanned="onBarcodeScanned"
      @close="closeScanner"
    />
  </div>
</template>

<script>
import BarcodeScannerModal from "@/components/BarcodeScannerModal.vue";

export default {
  components: {
    BarcodeScannerModal,
  },
  name: "ItemCreate",
  data() {
    return {
      form: {
        fullName: "",
        code: "",
        barCode: "",
        description: "",
        priceTTC: null,
      },
      errors: {},
      submitting: false,
      showScanner: false,
    };
  },
  methods: {
    openScanner() {
      this.showScanner = true;
    },
    closeScanner() {
      this.showScanner = false;
    },
    onBarcodeScanned(barcode) {
      console.log("Barcode received in ItemCreate:", barcode);
      this.form.barCode = barcode;
      this.closeScanner(); // Close the scanner modal
      this.$store.dispatch("notification/store", {
        status: "success",
        message: "Code-barres scanné avec succès.",
      });
    },
    goBack() {
      this.$router.back();
    },
    validate() {
      const errors = {};

      if (!this.form.fullName || !this.form.fullName.trim()) {
        errors.fullName = "Le nom de l'article est requis.";
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    buildPayload() {
      const payload = {
        fullName: this.form.fullName.trim(),
        code: this.form.code.trim() || null,
        barCode: this.form.barCode.trim() || null,
        description: this.form.description.trim() || null,
        priceTTC: this.form.priceTTC || null,
      };

      return payload;
    },
    async handleSubmit() {
      if (!this.validate()) return;

      this.submitting = true;
      try {
        const payload = this.buildPayload();
        await this.$store.dispatch("item/store", payload);
        this.$store.dispatch("notification/store", {
          status: "success",
          message: "Article créé avec succès.",
        });
        this.$router.push({ name: "items-list" });
      } catch (error) {
        console.error("Error creating item", error);
        this.$store.dispatch("notification/store", {
          status: "error",
          message:
            error.response?.data?.message || "Impossible de créer l'article.",
        });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.item-form-page {
  min-height: 100vh;
  background: var(--bg-secondary);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.page-header .btn {
  margin-bottom: 1rem;
}

.page-title {
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.page-subtitle {
  margin: 0;
  color: var(--text-secondary);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

label {
  font-weight: 600;
  color: var(--text-secondary);
}

input,
textarea {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  padding: 0.75rem 1rem;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(63, 81, 181, 0.1);
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.form-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

.has-error {
  border-color: var(--danger-color);
}

.error-text {
  color: var(--danger-color);
  font-size: 0.875rem;
  margin: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-light {
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.btn-light:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-primary:hover:not(:disabled) {
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .item-form-page {
    padding: 1rem;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}

.input-with-button {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}

.input-with-button .form-control {
  flex: 1;
}

.btn-scan {
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  flex-shrink: 0;
}

.btn-scan:hover {
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.btn-scan i {
  font-size: 1.25rem;
}

@media (max-width: 480px) {
  .page-title {
    font-size: 1.75rem;
  }
}
</style>
